var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center mt-lg-6"},_vm._l((_vm.statData),function(stat){return _c('div',{key:stat.icon,staticClass:"col-md-4"},[_c('Stat',{attrs:{"icon":stat.icon,"title":stat.title,"value":stat.value}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }